import { useEffect } from 'react';
import sitemeta from '../json/site-meta.json';   
import sitelist from '../json/site-list.json';   
 
const useFilterData = (data, coopid, wkfirst, wklast, saveLastDate, setReportsData, compareDateType) => {
    useEffect(() => {
        if (data) {
            // zero-pad a two-digit string representation of a number
            const padStr = (val) => val.toString().padStart(2, "0"); 

            // convert current date to yyyymmddhhnn string
            const crnt = new Date();
            const crntDateUTCString = crnt.getUTCFullYear().toString().substr(2) + padStr(crnt.getUTCMonth()+1) + padStr(crnt.getUTCDate()) + padStr(crnt.getUTCHours()) + padStr(crnt.getUTCMinutes());

            // ids in a specific group (if defined)
            const ids = coopid !== "*" ? sitelist[coopid] : null;

            const allReports = [];
            const lastDate = {};
            
            // filter desired records 
            data.forEach((entry) => {
                if (coopid === "*" || ids.includes(entry.nwsli)) { 
                    const entryDate = compareDateType === 'creation' ? new Date(entry.creationDate) : new Date(entry.year,entry.month-1,entry.day);
                    if (entryDate >= wkfirst && entryDate <= wklast) {
                        const formattedDate = entry.year.substr(2) + entry.month.padStart(2, "0") + entry.day.padStart(2, "0");
                        const formattedsweq = ["T",""].includes(entry.sweq) ? entry.sweq : parseFloat(entry.sweq).toFixed(1);
                        const formattedsnwd = ["T",""].includes(entry.snwd) ? entry.snwd : Math.round(parseFloat(entry.snwd));
                        allReports.push({
                            ...entry, 
                            lat: entry.nwsli in sitemeta ? parseFloat(sitemeta[entry.nwsli].lat).toFixed(4) : "", 
                            lon: entry.nwsli in sitemeta ? parseFloat(sitemeta[entry.nwsli].lon).toFixed(4) : "",
                            formattedsweq: formattedsweq,
                            formattedsnwd: formattedsnwd,
                            formattedDate: formattedDate,
                            formattedTime: entry.hour.padStart(2, "0") + "00",
                            currentDt: "DC" + crntDateUTCString,
                        });
                        // retain latest date for a station
                        if (!lastDate.hasOwnProperty(entry.nwsli) || formattedDate > lastDate[entry.nwsli]) {
                            lastDate[entry.nwsli] = formattedDate;
                        }
                    }
                }
            });
            setReportsData(allReports.filter((report) => !saveLastDate || report.formattedDate === lastDate[report.nwsli]))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);
};

export default useFilterData;